import { useEffect, useRef } from 'react';

export function useOnWindowVisible(onVisible: () => void) {
  const callbackRef = useRef(onVisible);

  useEffect(() => {
    callbackRef.current = onVisible;
  }, [onVisible]);

  useEffect(() => {
    const handleVisibility = () => {
      // Check for both Tab visibility and Window focus (Alt-Tab)
      if (document.visibilityState === 'visible' && document.hasFocus()) {
        callbackRef.current();
      }
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('focus', handleVisibility);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('focus', handleVisibility);
    };
  }, []);
}
